import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { EMPTY, Observable } from 'rxjs';
import { Template } from '../../models/template';
import { TemplateFilter } from '../../models/template-filter';

import * as fromAction from '../template.action';
import * as fromSelector from '../template.selector';
import { TemplateState } from '@modules/template/student/store/template.state';
import { ClassroomCourse, ClassroomCourseFilter } from '@modules/course/classroom/models';
import { Guid } from '@core/utils/guid';
import { CourseRequest } from "@modules/template/student/models/course-request";

@Injectable()
export class TemplateStoreService {
  constructor(private store: Store<TemplateState>) {}

  fetchTemplates(filter?: TemplateFilter) {
    this.store.dispatch(fromAction.FetchTemplates({ filter }));
  }

  fetchTemplate(id: string) {
    this.store.dispatch(fromAction.FetchTemplate({ id }));
  }

  addTemplateFilter(filter: TemplateFilter): void {}

  getTemplateFilter(): Observable<any> {
    return EMPTY;
  }

  addClassroomFilter(classroomFilter: ClassroomCourseFilter): void {
    this.store.dispatch(fromAction.AddClassroomFilter({ classroomFilter }));
  }

  resetClassroomFilter(): void {
    this.store.dispatch(fromAction.ResetClassroomFilter());
  }

  getClassroomFilter(): Observable<ClassroomCourseFilter> {
    return this.store.select(fromSelector.getClassroomFilter);
  }

  getTemplates(): Observable<Template[]> {
    return this.store.select(fromSelector.getTemplates);
  }

  getStudentTemplates(): Observable<Template[]> {
    return this.store.select(fromSelector.getStudentTemplates);
  }

  getInstructorTemplates(): Observable<Template[]> {
    return this.store.select(fromSelector.getInstructorTemplates);
  }

  getTemplate(templateId: string): Observable<Template> {
    if (Guid.IsGuid(templateId)) {
      return this.store.select(fromSelector.getTemplate(templateId));
    } else {
      return this.store.select(fromSelector.getTemplateBySlug(templateId));
    }
  }

  // Template Classroom Courses
  fetchClassroomCourse(templateId: string, filter?: ClassroomCourseFilter): void {
    this.store.dispatch(fromAction.FetchClassroomCourses({ templateId, filter }));
  }

  getClassroomCourses(): Observable<ClassroomCourse[]> {
    return this.store.select(fromSelector.getClassroomCourses);
  }

  removeClassroomCourses(): void {
    this.store.dispatch(fromAction.RemoveClassroomCourses());
  }

  fetchAllTemplates(filter?: TemplateFilter) {
    this.store.dispatch(fromAction.FetchAllTemplates({ filter }));
  }

  requestClassroomCourse(courseRequest: CourseRequest): void {
    this.store.dispatch(fromAction.RequestClassroomCourse({courseRequest}))
  }
}
